'use client';

import React, { useState } from 'react';
import { TwoImageProps } from '@/components/two-images/types';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { Dialog } from '@headlessui/react';
import Icon from '@/components/icon/Icon';

export const TwoImages: React.FC<TwoImageProps> = ({ images }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>(null);

  const openModal = (image: any) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  return (
    <>
      {/* Images Grid */}
      <div className="intro-header-element smzh-two-images w-full">
        <div className="container mx-auto grid grid-cols-12 gap-6 px-4 sm:px-0">
          <div className="col-start-1 col-end-13 flex flex-col gap-6 lg:col-start-3 lg:col-end-11 xl:col-start-4 xl:col-end-10">
            <div className="grid grid-cols-4 gap-4">
              {images.map((image, index) => (
                <div
                  key={index}
                  className="col-span-2 h-full w-full cursor-pointer"
                  onClick={() => openModal(image)}
                >
                  <BaseImage
                    {...image}
                    className="h-full w-full overflow-hidden rounded-lg"
                    classNameImage="w-full h-full object-cover"
                    sizes="50vw"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Dialog open={isModalOpen} onClose={closeModal} className="relative z-50">
        {/* Overlay */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          aria-hidden="true"
        />

        {/* Modal Content */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="relative w-full max-w-5xl rounded-lg bg-white shadow-lg">
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute right-4 top-4 text-gray-600 focus:outline-none"
              aria-label="Close"
            >
              <Icon name="x" size="24px" color="gray" />
            </button>

            {/* Selected Image */}
            {selectedImage && (
              <div className="p-4">
                <BaseImage
                  {...selectedImage}
                  className="w-full overflow-hidden rounded-lg"
                  classNameImage="w-full h-auto object-contain"
                  sizes="(max-width: 1024px) 100vw, 1024px"
                />
                {selectedImage?.imageDescription && (
                  <p className="mt-4 text-center text-gray-600">
                    {selectedImage.imageDescription}
                  </p>
                )}
              </div>
            )}
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};
